export const createTabObject = (data) => {
  return {
    id: data.RegionSelector,
    label: data.TabTitle,
    typeSelector: data.TabTypeSelector,
    region: data.RegionSelector
  }
}

export const createLocationObject = (data) => {
  return {
    eyebrow: data.Eyebrow,
    title: data.Title,
    region: data.Category,
    image: {
      src: data.Image,
      alt: data.ImageAltText
    },
    cta: {
      target: data.LinkTarget,
      text: data.LinkText,
      href: data.Link
    }
  }
}